"use client";

// In-page link to a section that scrolls there smoothly, the same way the
// catalog forms scroll to a section from their side menu. The hash is still
// written to the URL, so the section stays linkable.
export function SectionLink({ id, onClick, children, ...props }) {
  const handleClick = (event) => {
    const section = document.getElementById(id);
    if (!section) return;

    event.preventDefault();
    section.scrollIntoView({ behavior: "smooth", block: "start" });
    window.history.replaceState(null, "", `#${id}`);
    onClick?.();
  };

  return (
    <a href={`#${id}`} onClick={handleClick} {...props}>
      {children}
    </a>
  );
}
